/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ color: NonNullable<unknown> }} Settings_Highlight_Color_SwatchInputs */

const en_settings_highlight_color_swatch = /** @type {(inputs: Settings_Highlight_Color_SwatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Use highlight color ${i?.color}`)
};

const es_settings_highlight_color_swatch = /** @type {(inputs: Settings_Highlight_Color_SwatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usar el color de resaltado ${i?.color}`)
};

/**
* | output |
* | --- |
* | "Use highlight color {color}" |
*
* @param {Settings_Highlight_Color_SwatchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_highlight_color_swatch = /** @type {((inputs: Settings_Highlight_Color_SwatchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Highlight_Color_SwatchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_highlight_color_swatch(inputs)
	return en_settings_highlight_color_swatch(inputs)
});